export default "/images/8eec3769f23beb3d9726d17ddef02e61.png";